import React, { Suspense, lazy } from 'react';
import { ArrowRight, CheckCircle2, Building2, Hotel, ShoppingBag, GraduationCap, Lightbulb, Users, Zap, TrendingUp } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import AnahatsevaSection from '../components/AnahatsevaSection';
import SolutionsSection from '../components/SolutionsSection';
import IndustriesSection from '../components/IndustriesSection';
import WhyChooseSection from '../components/WhyChooseSection';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <Header />
      <main style={{ paddingTop: '180px' }}>
        <HeroSection />
        <AboutSection />
        <SolutionsSection />
        <AnahatsevaSection />
        <IndustriesSection />
        <WhyChooseSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;